import React, { useEffect, useState } from "react";
import axios from "../../../axios";
import CrossAttachmentAssessment from "../../../Assesment/pages/Create_Assessment/Attachment/CrossAttachmentAssessment";
const TeacherId = localStorage.getItem("Teacher_id");
const jsonTeacherId = JSON.parse(TeacherId);
const CreateUploadType = ({ question, nextQuestion, setQuestions }) => {
  const [fileSizeerror, setFileSizeError] = useState("")
  const [isValidFileType, setIsValidFileType] = useState(true);
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const handleReasonChange = (index, value) => {
    setQuestions((prev) => {
      const updatedCorrectAnswer = prev[nextQuestion].correct_answers.map(
        (answer, i) =>
          i === index
            ? {
              ...answer,
              reason_for_answer: {
                ...answer.reason_for_answer,
                explanation: value,
              },
            }
            : answer
      );

      const updatedQuestion = {
        ...prev[nextQuestion],
        correct_answers: updatedCorrectAnswer,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;
      return newQuestions;
    });
  };

  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.mp3|\.mp4|\.pptx|\.ppt)$/i;

    if (!allowedExtensions.exec(filePath.name)) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  const handleAttachmentChange = async (index, file) => {
    setFileSizeError("")
    if (file) {
      try {
        if (validateFileType(file)) {
          const allowedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/png",
            "audio/mpeg",
            "video/mp4",
          ];
          if (!allowedTypes.includes(file.type)) {
            window.alert(
              "Invalid file type. Only PDF, JPEG, PNG, MP3, and MP4 files are allowed."
            );
            return; // Skip this file and continue with the next one
          }

          const maxSizeInMB = file.type.startsWith("image")
            ? 10
            : file.type === "audio/mpeg"
              ? 10
              : 10;
          const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

          if (file.type === "application/pdf" && file.size > 10 * 1024 * 1024) {
            // window.alert("PDF file size exceeds 25 MB.");
            setFileSizeError("*The File You attached Exceeded 10MB.");
            return; // Skip this file and continue with the next one
          } else if (file.size > maxSizeInBytes) {
            // window.alert(`File size exceeds ${maxSizeInMB} MB.`);
            setFileSizeError("*The File You attached Exceeded The Limit.");
            return; // Skip this file and continue with the next one
          }

          let formData = new FormData();
          formData.append("name", file.name);
          formData.append("uploadQuestionAttachment", file);
          let res = await axios.post(
            `/api/v1/question/uploadAttachment/teacherId/${teacher_id}`,
            formData
          );
          res &&
            setQuestions((prev) => {
              const updatedCorrectAnswer = prev[nextQuestion].correct_answers.map(
                (answer, i) =>
                  i === index
                    ? {
                      ...answer,
                      reason_for_answer: {
                        ...answer.reason_for_answer,
                        attachment: res.data.data,
                      },
                    }
                    : answer
              );

              const updatedQuestion = {
                ...prev[nextQuestion],
                correct_answers: updatedCorrectAnswer,
              };

              const newQuestions = [...prev];
              newQuestions[nextQuestion] = updatedQuestion;
              return newQuestions;
            });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  return (
    <>
      <div className="col-12 ml-1">
        <div className="hw_mandatory_checkbox ml-1 mt-3">
          Add correct answer
        </div>
        {question?.correct_answers.length > 0 &&
          question?.correct_answers.map((cAnswer, index) => (
            <div key={index}>
              <div className="hw_mcq_option_box d-flex align-items-center">
                <input
                  onChange={(e) => handleReasonChange(index, e.target.value)}
                  // className="hw_mcq_option_box mt-2"
                  className="hw_add_reason"
                  placeholder="Correct Answer"
                  maxLength={250}
                  value={cAnswer.reason_for_answer.explanation}
                />
                <div>
                  <input
                    onChange={(e) => {
                      handleAttachmentChange(index, e.target.files[0]);
                    }}
                    type="file"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    id={`attachFileForReason${nextQuestion}`}
                    style={{ display: "none" }}
                    maxLength={100}
                  />
                  <label
                    style={{
                      backgroundColor: "#F0F0F0",
                      borderRadius: "8px",
                      cursor: "pointer",
                      margin: 0,
                    }}
                    className="d-flex align-items-center py-2 px-3"
                    htmlFor={`attachFileForReason${nextQuestion}`}
                  >
                    <img src="/images/Attach.svg" alt="" />
                    <span className="hw_mandatory_checkbox">&nbsp;Attach</span>
                  </label>
                </div>
              </div>
              {cAnswer.reason_for_answer.attachment && (
                <div style={{ width: "98%" }} className="mt-2 justify-content-end d-flex">
                  <CrossAttachmentAssessment
                    attachment={cAnswer.reason_for_answer.attachment}
                    isReasonForAnswer={true}
                    isEditable={true}
                    setQuestions={setQuestions}
                    nextQuestion={nextQuestion}
                  />
                </div>
              )}
              {!isValidFileType && (
                <p id="errorMsg">
                  Please upload a file with a valid extension (pdf, jpg, jpeg, png, pptx, ppt, mp3, mp4), Max Limit = 5.
                </p>
              )}
              <p className="ErrorMessage" style={{ textAlign: "right", marginRight: "20px" }}>{fileSizeerror}</p>
            </div>
          ))}
      </div>
    </>
  );
};

export default CreateUploadType;
